import clsx from 'clsx'

import { Icon } from '@fv/client-components'
import type { ListShipment } from '@fv/client-types'

import { getTransitStatus } from '../shipment-list/ActiveShipmentCardHeader'

export const ShipmentStatusIndicator = ({
  load: { status, pickup, workflow },
}: {
  load: Pick<ListShipment, 'pickup' | 'status' | 'workflow'>
}) => {
  const transitStatus = getTransitStatus(pickup?.status, workflow)

  const isDelivered = status === 'delivered'
  const isInTransit = status === 'picked-up'
  const isOutForDelivery = status === 'out-for-delivery'
  const isScheduled = status === 'confirmed'
  const isCanceled = status === 'canceled'
  return (
    <span>
      <Icon
        icon="dot-circle"
        className={clsx({
          'text-fv-orange': transitStatus === 'Scheduled',
          'text-fv-gray-dark': transitStatus !== 'Scheduled',
          '!text-fv-beer': isInTransit || isOutForDelivery,
          '!text-fv-green': isDelivered,
          '!text-fv-red': isCanceled,
        })}
      />
      <span>
        {isDelivered && 'Delivered'}
        {isInTransit && 'In Transit'}
        {isOutForDelivery && 'Out for Delivery'}
        {isScheduled && transitStatus}
        {isCanceled && 'Canceled'}
      </span>
    </span>
  )
}
